import { clearEmptyFields } from 'logic/validators/utils';
import { FormErrors } from 'redux-form';
import { isRequiredValidator } from 'logic/validators/validators';
import {
  ElitepaymentChangeSubscriptionRequest,
  ElitepaymentCreateSubscriptionIntentRequest,
  ElitepaymentPlan,
  ElitepaymentPrice,
} from 'logic/api-models/api-models';

export const MY_PRICING_FORM_NAME = 'my-pricing-form';

export interface MyPricingFormValues {
  [MyPricingFormFields.lessonUnitCount]?: number;
  [MyPricingFormFields.plan]?: ElitepaymentPlan;
}

export type MyPricingFormValidationErrors = FormErrors<MyPricingFormValues, string>

export const validateMyPricingForm = (formValues: MyPricingFormValues) => {
  const { lessonUnitCount, plan } = formValues;

  const errors: MyPricingFormValidationErrors = {
    lessonUnitCount: isRequiredValidator(lessonUnitCount),
    plan: isRequiredValidator(plan),
  };

  return clearEmptyFields(errors);
};

export enum MyPricingFormFields {
  lessonUnitCount = 'lessonUnitCount',
  plan = 'plan',
}

// only works for euro
export const parsePrice = (price?: ElitepaymentPrice) => {
  const priceUnit = parseFloat(price?.unitAmount?.toString() || '')
    .toFixed(2)
    .toString()
    .replace('.', ',');

  return priceUnit + ((price?.currency === 'EUR') ? '\xa0€' : '');
};

// only works for euro
export const generateTotalMonthlyPrice = (lessonUnits: number, price?: ElitepaymentPrice ) => {
  const monthlyPrice = price?.unitAmount ? (price?.unitAmount * lessonUnits) : 0;
  const priceUnit = parseFloat(monthlyPrice.toString() || '')
    .toFixed(2)
    .toString()
    .replace('.', ',');

  return priceUnit + ((price?.currency === 'EUR') ? '€' : '');
};

// only works for euro
export const calculateAndParseAbsolutDiscountPrice = (priceA?: ElitepaymentPrice, priceB?: ElitepaymentPrice, lessonUnitCount: number) => {
  const price = parseFloat(priceA?.unitAmount?.toString() || '') - parseFloat(priceB?.unitAmount?.toString() || '');
  const priceUnit = (price * lessonUnitCount)
    .toFixed(2)
    .toString()
    .replace('.', ',');

  return priceUnit + ((priceA?.currency === 'EUR') ? '€' : '');
};

export const calculateAndParseRelativeDiscountPrice = (priceA?: ElitepaymentPrice, priceB?: ElitepaymentPrice) => {
  const price =  parseFloat(priceA?.unitAmount?.toString() || '') / parseFloat(priceB?.unitAmount?.toString() || '');
  const priceUnit = Math.round((1 - price) * 100);

  return priceUnit + '%';
};

export const calculateAndParseTotalPrice = (lessonunitCount: number, price?: ElitepaymentPrice) => {
  const totalPrice = (price?.unitAmount || 0) * lessonunitCount;
  const totalPriceUnit = parseFloat(totalPrice.toString() || '')
    .toFixed(2)
    .toString()
    .replace('.', ',');

  return totalPriceUnit + ((price?.currency === 'EUR') ? '€' : '');
};

export const mapMyPricingFormToRequest: (
  formValues: MyPricingFormValues | undefined
) => ElitepaymentCreateSubscriptionIntentRequest = (formValues) => {

  const request: ElitepaymentCreateSubscriptionIntentRequest = {
    planId: formValues?.plan?.id || '',
    planVersionHash: formValues?.plan?.versionHash || '',
    elitehoursPerMonth: formValues?.lessonUnitCount || 0,
  };

  return request;
};

export const mapMyPricingFormToSubsciptionChangeRequest: (
  formValues?: MyPricingFormValues,
  subscriptionVersionHash?: string,
) => ElitepaymentChangeSubscriptionRequest = (formValues, subscriptionVersionHash) => {

  const request: ElitepaymentChangeSubscriptionRequest = {
    elitehoursPerMonth: formValues?.lessonUnitCount || 0,
    planVersionHash: formValues?.plan?.versionHash || '',
    subscriptionVersionHash: subscriptionVersionHash || '',
    planId: formValues?.plan?.id || '',
  };

  return request;
};
